import { createEndpoints } from '../../_helpers/utile/endpoint.helper';

export const FILTERS_ENDPOINTS = {
  V1: createEndpoints('v1', {
    FILTERS_DATA: '/filters-data',
    SAVED_FILTERS: '/saved-filters',
  }),
} as const;
